import { render } from "./WidgetCard.vue?vue&type=template&id=5cfc3a38&ts=true"
import script from "./WidgetCard.vue?vue&type=script&lang=ts"
export * from "./WidgetCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__